import ITeamBasicInfoEntity from "./ITeamBasicInfoEntity";

/**
 * Basic team information entity that contains minimal team data
 */
export default class TeamBasicInfoEntity implements ITeamBasicInfoEntity {
    teamId: string;
    name: string;
    crossLocationShiftsEnabled: boolean;

    constructor(teamId: string, name: string, crossLocationShiftsEnabled: boolean) {
        this.teamId = teamId;
        this.name = name;
        this.crossLocationShiftsEnabled = crossLocationShiftsEnabled;
    }

    /**
     * Function that converts json from service response to TeamBasicInfoEntity
     * @param jsonData - response from service
     */
    static fromJson(jsonData: any): ITeamBasicInfoEntity {
        if (!jsonData) {
            return null;
        }
        return new TeamBasicInfoEntity(jsonData.teamId, jsonData.name, jsonData.crossLocationShiftsEnabled);
    }
}
